var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.reportingComponent)?_c(_vm.reportingComponent,{key:(_vm.accessToken + "-" + _vm.payoutId),tag:"component"}):_c('ui-loading',{attrs:{"inline":""}})}
var staticRenderFns = []

export { render, staticRenderFns }